import { reformatDateToMonthDayYear } from "app/utils/dateUtils"

export const dateChangeService = (event, calendarAPI, setCustomCalendarViewTitle, setCalendarRangeStartDate, setCalendarRangeEndDate) => {
  if (event === 'prev')
    calendarAPI.prev()
  else if (event === 'next')
    calendarAPI.next()
  else if (event === 'today')
    calendarAPI.today()
  setCustomCalendarViewTitle(calendarAPI?.currentDataManager?.data?.viewTitle)
  setCalendarRangeStartDate(reformatDateToMonthDayYear(calendarAPI?.currentDataManager?.data?.dateProfile?.activeRange?.start))
  setCalendarRangeEndDate(reformatDateToMonthDayYear(calendarAPI?.currentDataManager?.data?.dateProfile?.activeRange?.end))
}

